import { QBO_TAX_CODE } from './rates.js';
/** The complete Canadian sales-tax category registry. Single source for UI + sync. */
export const TAX_CATEGORIES = {
    none: { label: 'No Tax', ratePct: 0, components: {}, qboTaxCodeId: QBO_TAX_CODE.ZERO_RATED },
    GST: { label: 'GST (5%)', ratePct: 5, components: { gst: 5 }, qboTaxCodeId: QBO_TAX_CODE.GST },
    'GST+QST': { label: 'GST+QST QC (14.975%)', ratePct: 14.975, components: { gst: 5, qst: 9.975 }, qboTaxCodeId: QBO_TAX_CODE.GST_QST },
    HST: { label: 'HST ON (13%)', ratePct: 13, components: { hst: 13 }, qboTaxCodeId: null },
    HST15: { label: 'HST (15%)', ratePct: 15, components: { hst: 15 }, qboTaxCodeId: null },
    'GST+PST': { label: 'GST+PST BC (12%)', ratePct: 12, components: { gst: 5, pst: 7 }, qboTaxCodeId: QBO_TAX_CODE.GST_PST },
};
/** Ordered list for rendering a dropdown (None first, then ascending complexity). */
export const TAX_CATEGORY_ORDER = ['none', 'GST', 'GST+QST', 'HST', 'HST15', 'GST+PST'];
/** Compute the tax amount for a stored category. */
export function taxForCategory(amount, category) {
    if (!category)
        return 0;
    return amount * (TAX_CATEGORIES[category].ratePct / 100);
}
/**
 * Bridge a destination province to the UI tax category (place of supply).
 * Customer-specific exceptions (e.g. DND -> GST) are handled by resolveSalesTax,
 * not here; this is the pure province -> category map.
 */
export function provinceToTaxCategory(province) {
    switch (province) {
        case 'QC':
            return 'GST+QST';
        case 'ON':
            return 'HST';
        case 'NB':
        case 'NS':
        case 'NL':
        case 'PE':
            return 'HST15';
        case 'BC':
            return 'GST+PST';
        default:
            return 'GST';
    }
}
//# sourceMappingURL=categories.js.map